(function() {
    'use strict';

    angular
        .module('app.comprobantesPago')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/comprobantes-pago',
                config: {
                    templateUrl: 'app/comprobantesPago/comprobantesPago.html',
                    controller: 'ComprobantesPago',
                    controllerAs: 'vm',
                    title: 'ComprobantesPago'
                }
            }
        ];
    }
})();
